import React from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';
import { useLocation } from 'react-router';
import core, { App } from '@gin-betting/core';

import { BettingWidgets } from 'app-constants';
import { usePureSelector, useWidgetSettings } from 'hooks';
import globalMessages from 'messages';
import ui from 'modules/ui';

import './navigation.scss';

const {
    viewport: {
        selectors: { selectIsCompact },
    },
} = core;

const {
    components: { ListNav },
} = ui;

const NAVIGATION_TABS: Array<{ title: MessageDescriptor; link: string }> = [
    { title: globalMessages.csport, link: App.Routes.CLASSIC },
    { title: globalMessages.live, link: App.Routes.LIVE_LIST },
    { title: globalMessages.esport, link: App.Routes.ESPORT },
    { title: globalMessages.results, link: App.Routes.RESULTS_LIST },
    { title: globalMessages.outrights, link: App.Routes.OUTRIGHTS_LIST },
];

const Navigation: React.FC = () => {
    const { pathname } = useLocation();
    const { formatMessage } = useIntl();

    const { isShowExtraNavigation } = useWidgetSettings({
        widget: BettingWidgets.NAVIGATION,
    });

    const isCompact = usePureSelector(state => selectIsCompact(state, {}));

    if (!isShowExtraNavigation || isCompact) return null;

    const tabs = NAVIGATION_TABS.map(tab => ({
        ...tab,
        title: formatMessage(tab.title),
        isDisabled: tab.link === pathname,
    }));

    return (
        <div styleName="container">
            <ListNav tabs={tabs} />
        </div>
    );
};

export default React.memo(Navigation);
